/* Same quantity/plan purchase flow as the verified final hero, without gallery dependencies. */
(()=>{'use strict';
function init(root){
if(!root || root.dataset.initialized)return;
root.dataset.initialized='true';
const $=s=>root.querySelector(s), $$=s=>[...root.querySelectorAll(s)];
const fmt=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:cents%100===0?0:2,maximumFractionDigits:2}).format(cents/100);
const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
const cards=$$('.evb-card'),subscribe=$('[data-subscribe]');
  const isReady = (card) => card.dataset[subscribe.checked ? 'subReady' : 'oneReady'] === 'true';
  function selectAvailable(){
    const available = cards.filter(isReady);
    cards.forEach(card => {
      const ready = isReady(card);
      card.hidden = !ready;
      card.querySelector('input').disabled = !ready;
    });
    const chosen = available.find(card => card.querySelector('input').checked) || available[0];
    cards.forEach(card => {
      card.querySelector('input').checked = card === chosen;
      card.classList.toggle('is-selected', card === chosen);
    });
    $('[data-add]').disabled = !chosen || root.dataset.offersVerified !== 'true';
    if (root.dataset.offersVerified !== 'true') $('[data-cart-status]').textContent = 'These offers are being prepared. Please use the regular product page until checkout is verified.';
    else if (!chosen) $('[data-cart-status]').textContent = 'This purchase option is not available yet.';
    return chosen;
  }
  function selection(){
    const card = selectAvailable();
    if (!card) return null;
    const quantity = Number(card.dataset.bottles);
    const subscribed = subscribe.checked;
    const total = Number(card.dataset[subscribed ? 'subCents' : 'baseCents']);
    return {bundle:card.dataset.plan,bottles:quantity,sizeMl:50,purchaseType:subscribed?'subscription':'one-time',currency:'USD',totalCents:total,unitCents:total/quantity,oneTimeBundleCents:Number(card.dataset.baseCents),retailValueCents:Number(card.dataset.retailCents),renewalDays:subscribed?Number(card.dataset.days):null,variantId:Number(card.dataset[subscribed ? 'subVariantId' : 'oneVariantId']),cartQuantity:Number(card.dataset[subscribed ? 'subQuantity' : 'oneQuantity']),sellingPlanId:subscribed?Number(card.dataset.sellingPlanId):null,shippingIncluded:true};
  }
  function renderPrices(animate){
    selectAvailable();
    cards.forEach(card=>{
      if (!isReady(card)) return;
      const qty=Number(card.dataset.bottles);
      const total=Number(card.dataset[subscribe.checked ? 'subCents' : 'baseCents']);
      const retail=Number(card.dataset.retailCents);
      card.classList.toggle('is-selected',card.querySelector('input').checked);
      card.querySelector('[data-unit]').textContent=fmt(total/qty);
      card.querySelector('[data-unit-was]').textContent=fmt(retail/qty);
      card.querySelector('[data-unit-was]').hidden=total>=retail;
      card.querySelector('[data-charge]').textContent=fmt(total);
      const save=card.querySelector('[data-saving]'),percent=Math.round((1-total/retail)*100);
      save.textContent='Save '+percent+'%';save.hidden=percent===0;
      if(animate&&!reducedMotion.matches){const p=card.querySelector('.evb-price');p.classList.remove('is-updating');void p.offsetWidth;p.classList.add('is-updating');}
    });
    const s=selection();
    if (!s) {
      $('[data-total]').textContent='Unavailable';
      $('[data-add-label]').textContent='Currently unavailable';
      return;
    }
    $('[data-total]').textContent=fmt(s.totalCents);
    $('[data-total-was]').textContent=fmt(s.retailValueCents);
    $('[data-total-comparison]').hidden=s.retailValueCents===s.totalCents;
    const saving=s.retailValueCents-s.totalCents;
    $('[data-total-saving]').textContent=saving>0?'You save '+fmt(saving)+' · '+Math.round(saving/s.retailValueCents*100)+'%':'One bottle. One payment.';
    $('[data-total-detail]').textContent=s.bottles+' full-size '+(s.bottles===1?'bottle':'bottles')+' · shipped together'+(s.renewalDays?' every '+(s.renewalDays/30)+' months':'');
    $('[data-add-label]').textContent=($('[data-add]').dataset.buttonLabel || 'Add to cart')+' — '+fmt(s.totalCents);
    const billing=$('[data-billing]');billing.replaceChildren();
    const strong=document.createElement('strong');
    strong.textContent=billing.dataset.shipping || 'Free shipping.';
    const recurring=s.renewalDays?' '+fmt(s.totalCents)+' every '+(s.renewalDays/30)+' months until canceled.':'';
    billing.append(strong,document.createTextNode(recurring+' '+(billing.dataset.tax || 'Applicable tax calculated at checkout.')));
    if (root.dataset.offersVerified === 'true') $('[data-cart-status]').textContent='';
    root.dispatchEvent(new CustomEvent('evori:selection-change',{bubbles:true,detail:s}));
  }
  cards.forEach(card=>card.querySelector('input').addEventListener('change',()=>renderPrices(false)));
  subscribe.addEventListener('change',()=>renderPrices(true));
  if (!cards.some(card => card.dataset.subReady === 'true')) {
    subscribe.checked=false;
    subscribe.disabled=true;
    subscribe.closest('.evb-subscribe').hidden=true;
  }
  renderPrices(false);

  $('[data-add]').addEventListener('click',async()=>{
    const s=selection();
    if (root.dataset.offersVerified !== 'true' || !s || !s.variantId || (s.purchaseType==='subscription' && !s.sellingPlanId)) return;
    const button=$('[data-add]');button.disabled=true;button.setAttribute('aria-busy','true');
    $('[data-cart-status]').textContent='Adding your selection…';
    const drawer=document.querySelector('cart-drawer.evori-cart-drawer, cart-drawer');
    if (drawer?.setActiveElement) drawer.setActiveElement(button);
    try {
      const item={id:s.variantId,quantity:s.cartQuantity};
      if (s.sellingPlanId) item.selling_plan=s.sellingPlanId;
      const payload={items:[item]};
      if (drawer?.getSectionsToRender) {
        payload.sections=drawer.getSectionsToRender().map(section=>section.id);
        payload.sections_url=location.pathname;
      }
      const response=await fetch(window.routes?.cart_add_url || '/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(payload)});
      const state=await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add this item.');
      if (drawer?.renderContents && state.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
      } else {
        location.assign(window.routes?.cart_url || '/cart');
        return;
      }
      $('[data-cart-status]').textContent='Added to your cart.';
    }
    catch(error){$('[data-cart-status]').textContent=error?.message || 'We couldn’t add your selection. Please try again.';console.error('EVORI cart:',error);}
    finally{button.disabled=false;button.removeAttribute('aria-busy');}
  });

}
function scan(scope){scope.querySelectorAll('[data-evori-buybox]').forEach(init);}
scan(document);
if(!window.evoriSupplyEditorBound){
window.evoriSupplyEditorBound=true;
document.addEventListener('shopify:section:load',e=>scan(e.target));
document.addEventListener('click',e=>{
 const link=e.target.closest('[data-evori-purchase]');
 if(!link)return;
 const box=document.querySelector('[data-evori-buybox]');
 const toggle=box?.querySelector('[data-subscribe]');
 if(!toggle || toggle.disabled)return;
 toggle.checked=link.dataset.evoriPurchase==='subscription';
 toggle.dispatchEvent(new Event('change',{bubbles:true}));
});
}
})();
